{
  "account.backToSignIn": "Terug naar inloggen",
  "account.birthDate": "Geboortedatum",
  "account.birthDateHint": "Onder de leeftijd die in jouw land geldt, ga je niet alleen naar een festival.",
  "account.childProfile": "Kinderprofiel",
  "account.country": "Land",
  "account.countryOption": "Land: {{name}}",
  "account.day": "Dag",
  "account.dayShort": "DD",
  "account.delete": "Mijn account verwijderen",
  "account.deleteConfirm": "Definitief verwijderen",
  "account.deleteExplain": "Je account, je groepen, je gedeelde locaties en je metingen worden gewist, net als gekoppelde kinderprofielen. Dit is definitief. Het programma, je favorieten en je markeringen blijven op deze telefoon.",
  "account.deletePasswordHint": "Voer je wachtwoord in om te bevestigen.",
  "account.deleted": "Je account is verwijderd.",
  "account.displayName": "Weergegeven naam",
  "account.email": "E-mailadres",
  "account.forgot": "Wachtwoord vergeten?",
  "account.invalidCredentials": "Adres of wachtwoord onjuist.",
  "account.invitationCode": "Uitnodigingscode",
  "account.invitationHint": "Registratie is niet open: een account maak je aan met een code die iemand je geeft.",
  "account.invitationInvalid": "Deze uitnodigingscode is niet geldig.",
  "account.invitationScanned": "Uitnodiging herkend: vul het formulier in.",
  "account.month": "Maand",
  "account.monthShort": "MM",
  "account.newPassword": "Nieuw wachtwoord",
  "account.open": "Account",
  "account.password": "Wachtwoord",
  "account.passwordHint": "Minimaal twaalf tekens.",
  "account.registrationFailed": "De registratie kon niet worden voltooid. Controleer de ingevoerde gegevens.",
  "account.resetCode": "Ontvangen code",
  "account.resetConfirm": "Wachtwoord wijzigen",
  "account.resetDone": "Wachtwoord gewijzigd. Log in met het nieuwe.",
  "account.resetExplain": "Voer het adres van je account in: we sturen er een code van zes cijfers naartoe.",
  "account.resetInvalid": "Deze code is niet geldig of verlopen. Vraag een nieuwe aan.",
  "account.resetSend": "Stuur me een code",
  "account.resetSent": "Als een account dit adres gebruikt, is er zojuist een code naartoe gestuurd. Die is 15 minuten geldig.",
  "account.signIn": "Inloggen",
  "account.signOut": "Uitloggen",
  "account.signUp": "Een account aanmaken",
  "account.signedInAs": "Ingelogd als {{name}}",
  "account.title": "Mijn account",
  "account.toggleToSignIn": "Ik heb al een account",
  "account.toggleToSignUp": "Ik heb nog geen account",
  "account.tooMany": "Te veel pogingen. Probeer het over een paar minuten opnieuw.",
  "account.tooYoung": "Het account moet worden aangemaakt door een volwassene, die er daarna een kinderprofiel aan kan koppelen.",
  "account.unreachable": "Server onbereikbaar. Probeer het opnieuw zodra het netwerk terug is.",
  "account.year": "Jaar",
  "account.yearShort": "JJJJ",
  "aerial.download": "Luchtbeeld downloaden",
  "aerial.downloading": "Bezig met downloaden…",
  "aerial.explain": "Een dronebeeld van het terrein. Het neemt {{size}} MB in beslag en wordt maar één keer gedownload.",
  "aerial.failed": "Downloaden mislukt. Probeer het via wifi.",
  "aerial.ready": "Luchtbeeld offline beschikbaar",
  "aerial.remove": "Luchtbeeld wissen",
  "aerial.title": "Luchtbeeld",
  "aerial.wifiHint": "Doe dit bij voorkeur vooraf, via wifi.",
  "common.cancel": "Annuleren",
  "common.close": "Sluiten",
  "common.retry": "Opnieuw proberen",
  "common.search": "Zoeken",
  "crew.apiUnavailable": "Groep niet beschikbaar: geen server ingesteld",
  "crew.background.active": "Je locatie wordt ook verstuurd met je telefoon in je zak, ongeveer elke minuut zolang je beweegt.",
  "crew.background.allow": "Locatie altijd toestaan",
  "crew.background.foregroundOnly": "Je vrienden zien je alleen als de app open is.",
  "crew.background.notificationBody": "Tot {{time}}. Open de app om te stoppen.",
  "crew.background.notificationTitle": "Locatie gedeeld met {{crew}}",
  "crew.codeLabel": "Groepscode",
  "crew.create": "Groep aanmaken",
  "crew.error.festival": "Dit festival staat nog niet op de server, dus er kan geen groep worden gemaakt.",
  "crew.error.notFound": "Geen groep heeft deze code. Controleer hem bij de persoon die de groep heeft gemaakt.",
  "crew.error.notMember": "Je hoort niet meer bij deze groep, of hij is verlopen.",
  "crew.error.refused": "De server heeft het verzoek geweigerd. Probeer het later opnieuw.",
  "crew.error.session": "Je sessie is verlopen. Log opnieuw in.",
  "crew.error.tooMany": "Te veel pogingen. Probeer het over een paar minuten opnieuw.",
  "crew.join": "Deelnemen met een code",
  "crew.lastSeen": "{{minutes}} min geleden gezien",
  "crew.lastSeenDays": "{{days}} d geleden gezien",
  "crew.lastSeenHours": "{{hours}} u geleden gezien",
  "crew.nameLabel": "Groepsnaam",
  "crew.near": "Bij {{place}}",
  "crew.needAccount": "Een account is nodig om deel te nemen",
  "crew.noCrew": "Nog geen groep",
  "crew.noPosition": "Deelt de locatie niet",
  "crew.offline": "Offline — laatst bekende informatie",
  "crew.positionStale": "Oude locatie",
  "crew.rallyNeedPosition": "Zet je locatie aan om te zien waar het is",
  "crew.rallyOnMap": "Groepsafspraak",
  "crew.rallySetAt": "Geplaatst om {{time}}",
  "crew.section.members": "De groep",
  "crew.section.sharing": "Mijn locatie",
  "crew.setRally": "Hier een ontmoetingspunt instellen",
  "crew.shareCode": "Laat deze code scannen of lees hem voor",
  "crew.shareOff": "Locatiedeling uitgeschakeld",
  "crew.sharing.APPROXIMATE": "Globale zone",
  "crew.sharing.OFF": "Niet delen",
  "crew.sharing.PRECISE": "Precieze locatie",
  "crew.sharingFor": "{{hours}} uur delen",
  "crew.sharingUntil": "Delen tot {{time}}",
  "crew.showOnMap": "Op de plattegrond tonen",
  "crew.title": "Mijn groep",
  "crew.you": "Dat ben jij",
  "diary.empty": "Nog geen optredens gemarkeerd",
  "diary.markSeen": "Ik was erbij",
  "diary.notYet": "Nog niet begonnen",
  "diary.photosCount": "{{count}} foto('s) gemaakt tijdens het festival",
  "diary.photosDenied": "Toegang tot foto's geweigerd",
  "diary.photosExplain": "Foto's blijven op je telefoon: er wordt niets gekopieerd of verstuurd.",
  "diary.photosNone": "Geen foto's gevonden in deze periode",
  "diary.photosPermission": "Toegang tot foto's toestaan",
  "diary.photosTitle": "Foto's van dit festival",
  "diary.stats": "{{performances}} optreden(s) · {{artists}} artiest(en) · {{days}} dag(en)",
  "diary.unmarkSeen": "Uit dagboek verwijderen",
  "festival.checkedOn": "gecontroleerd op {{date}}",
  "festival.reportHint": "Een fout? Tik op deze melding, of houd een optreden of plek ingedrukt.",
  "festival.source": "Programma overgenomen van: {{source}}",
  "festival.unofficial": "Onofficiële pagina: informatie niet gecontroleerd door de organisator.",
  "keyring.add": "Een festival toevoegen",
  "keyring.already": "Staat al bij je festivals",
  "keyring.change": "Van festival wisselen",
  "keyring.current": "Nu geopend",
  "keyring.empty": "Nog geen festival toegevoegd.",
  "keyring.noResult": "Geen festival gevonden.",
  "keyring.offline": "Zoeken vereist netwerk. Reeds toegevoegde festivals blijven beschikbaar.",
  "keyring.pinFailed": "Je telefoon kon het pictogram niet toevoegen.",
  "keyring.pinHint": "Een pictogram voor dit festival dat de app er direct op opent.",
  "keyring.pinShortcut": "Toevoegen aan beginscherm",
  "keyring.remove": "Verwijderen",
  "keyring.removed": "Festival verwijderd. De offline-inhoud is gewist.",
  "keyring.search": "Naam van het festival of de stad",
  "keyring.searchHint": "Je kunt ook je ticket scannen: het festival voegt zichzelf toe.",
  "keyring.title": "Mijn festivals",
  "lineup.all": "Volledig programma",
  "lineup.cancelled": "Geannuleerd",
  "lineup.conflict": "Overlapt met een andere favoriet",
  "lineup.conflictLine": "{{first}} en {{second}} overlappen {{minutes}} min",
  "lineup.conflictsTitle": "{{count}} overlapping(en) tussen je favorieten",
  "lineup.delayed": "Vertraagd",
  "lineup.favorite": "Toevoegen aan mijn favorieten",
  "lineup.favoritesOnly": "Mijn favorieten",
  "lineup.noPerformances": "Geen optredens gepland",
  "lineup.reminderBody": "{{artist}} over {{minutes}} min · {{stage}}",
  "lineup.reminderTitle": "Begint zo",
  "lineup.remindersPlanned": "{{count}} herinnering(en) ingesteld",
  "lineup.remindersUnavailable": "Herinneringen niet beschikbaar — meldingen geweigerd",
  "lineup.removeFavorite": "Uit favorieten verwijderen",
  "lineup.title": "Programma",
  "location.denied": "Locatie geweigerd — de plattegrond blijft bruikbaar",
  "location.granted": "Locatie ingeschakeld",
  "mail.reset.body": "Hallo {{name}},\n\nHier is je code om een nieuw Festipal-wachtwoord te kiezen:\n\n{{code}}\n\nDe code is {{minutes}} minuten geldig. Heb je niets aangevraagd? Negeer dan dit bericht: je wachtwoord blijft hetzelfde.\n\nFestipal",
  "mail.reset.subject": "Je Festipal-code: {{code}}",
  "map.bearing.east": "naar het oosten",
  "map.bearing.north": "naar het noorden",
  "map.bearing.northeast": "naar het noordoosten",
  "map.bearing.northwest": "naar het noordwesten",
  "map.bearing.south": "naar het zuiden",
  "map.bearing.southeast": "naar het zuidoosten",
  "map.bearing.southwest": "naar het zuidwesten",
  "map.bearing.west": "naar het westen",
  "map.closeDetail": "Sluiten",
  "map.distanceMeters": "{{distance}} m verderop",
  "map.listView": "Bekijk de lijst met locaties",
  "map.loadError": "De plattegrond kon niet worden geladen",
  "map.loading": "Plattegrond wordt voorbereid…",
  "map.locateMe": "Mij lokaliseren",
  "map.offlineBadge": "Offline plattegrond",
  "map.offlineNotice": "Plattegrond offline beschikbaar",
  "map.tapHint": "Tik op een punt om te zien wat het is.",
  "map.title": "Plattegrond",
  "marker.car": "Mijn auto",
  "marker.dropHere": "Hier een markering plaatsen",
  "marker.meeting": "Ontmoetingspunt",
  "marker.needLocation": "Locatie nodig om een markering te plaatsen",
  "marker.other": "Markering",
  "marker.remove": "Markering verwijderen",
  "marker.tent": "Mijn tent",
  "me.account": "Mijn account",
  "me.accountAnonymous": "Nog geen account",
  "me.diary": "Mijn boekje",
  "me.diaryCount": "{{count}} optreden(s) gezien",
  "me.festivals": "Mijn festivals",
  "me.festivalsCount": "{{count}} festival(s) toegevoegd",
  "me.scan": "Een code scannen",
  "me.scanHint": "Ticket, uitnodiging of groep",
  "me.survey": "Terrein karteren",
  "me.surveyHint": "Ontbrekende plekken vastleggen",
  "me.title": "Ik",
  "ping.age": "{{minutes}} min geleden",
  "ping.cancel": "We hebben elkaar gevonden",
  "ping.channel": "Oproepen van de groep",
  "ping.from": "{{name}}: ‘Kom naar me toe!’",
  "ping.notificationBody": "Tik om te zien waar.",
  "ping.notificationTitle": "{{name}}: ‘Kom naar me toe!’",
  "ping.onMap": "Naar {{name}}",
  "ping.send": "Kom naar me toe: locatie sturen",
  "ping.sendHint": "Je exacte locatie gaat naar je groep, {{minutes}} min lang.",
  "ping.sent": "Je hebt je groep om {{time}} geroepen, tot {{until}}.",
  "places.allCategories": "Alle",
  "places.awaitingLocation": "Locatie wordt bepaald…",
  "places.count": "{{count}} locatie(s)",
  "places.direction": "{{distance}} m {{bearing}} · {{minutes}} min lopen",
  "places.fromHere": "Afstanden vanaf deze locatie berekenen",
  "places.locationUnavailable": "Locatie niet beschikbaar — gesorteerd op naam",
  "places.noResult": "Geen locatie gevonden",
  "places.originDevice": "Afstanden vanaf mijn locatie",
  "places.originManual": "Afstanden vanaf {{place}}",
  "places.pickOrigin": "Kies een referentiepunt uit de lijst",
  "places.searchPlaceholder": "Zoek een locatie",
  "places.title": "Locaties",
  "places.unverified": "Niet geverifieerd",
  "places.useMyLocation": "Mijn locatie gebruiken",
  "poi.category.accessible": "Rolstoeltoegang",
  "poi.category.bar": "Bar",
  "poi.category.charging": "Telefoon opladen",
  "poi.category.entrance": "Ingang",
  "poi.category.exit": "Nooduitgang",
  "poi.category.firstaid": "EHBO-post",
  "poi.category.food": "Eten",
  "poi.category.info": "Infopunt",
  "poi.category.lockers": "Bagagekluizen",
  "poi.category.stage": "Podium",
  "poi.category.toilets": "Toiletten",
  "poi.category.water": "Waterpunt",
  "report.comment": "Vertel gerust meer (optioneel)",
  "report.failed": "Niet aangenomen. Probeer het later opnieuw.",
  "report.festival": "Het programma of de kaart in het algemeen",
  "report.kind.CANCELLED": "Afgelast",
  "report.kind.GONE": "Bestaat niet (meer)",
  "report.kind.MISSING": "Er ontbreekt een optreden of plek",
  "report.kind.OTHER": "Iets anders",
  "report.kind.WRONG_PLACE": "Op de verkeerde plek",
  "report.kind.WRONG_STAGE": "Verkeerd podium",
  "report.kind.WRONG_TIME": "Verkeerde tijd",
  "report.offline": "Offline: er is niets verstuurd. Probeer het opnieuw zodra je bereik hebt.",
  "report.openSource": "Bron openen",
  "report.send": "Versturen",
  "report.sent": "Bedankt! Het is doorgegeven aan wie deze pagina bijhoudt.",
  "report.title": "Fout melden",
  "report.tooMany": "Te veel meldingen tegelijk. Probeer het over een paar minuten opnieuw.",
  "safety.callEmergency": "Noodnummer bellen",
  "safety.emergencyTitle": "Hulp en EHBO",
  "safety.nearestFirstAid": "Dichtstbijzijnde EHBO-post",
  "scan.close": "Scanner sluiten",
  "scan.crewFound": "Groep herkend: {{code}}",
  "scan.festivalFound": "Festival herkend: {{slug}}",
  "scan.hint": "Scan je ticket of een groepscode",
  "scan.invitationFound": "Uitnodiging herkend",
  "scan.open": "Een code scannen",
  "scan.permission": "Camera toestaan",
  "scan.permissionDenied": "Camera geweigerd — voer de code handmatig in",
  "scan.privacy": "Alleen de festivalcode wordt gelezen. Verder wordt niets van het ticket bewaard.",
  "scan.title": "Scannen",
  "scan.unknown": "Code niet herkend. Komt hij van een ticketverkoper, zoek je festival dan in de lijst.",
  "shortcut.add": "Toevoegen",
  "shortcut.later": "Later",
  "shortcut.offer": "{{name}} aan je beginscherm toevoegen?",
  "survey.addPhoto": "Een foto toevoegen",
  "survey.category": "Soort plek",
  "survey.comment": "Nuttige toelichting (optioneel)",
  "survey.intro": "Loop naar de plek die je wilt vastleggen, blijf stilstaan tijdens de meting en geef de plek een naam.",
  "survey.measuring": "{{used}} metingen behouden · nauwkeurigheid {{accuracy}} m",
  "survey.moderationNotice": "Elke opname wordt nagekeken voordat ze in de app verschijnt.",
  "survey.name": "Naam van de plek",
  "survey.needAccount": "Een account is nodig: een opname wordt aan de maker toegeschreven.",
  "survey.needLocation": "Toegang tot de locatie is nodig om een punt vast te leggen.",
  "survey.open": "Karteren",
  "survey.photoAttached": "Foto toegevoegd",
  "survey.photoRejected": "Foto geweigerd door het automatische filter. De opname zelf is wel verstuurd.",
  "survey.queue": "Mijn opnamen",
  "survey.queueEmpty": "Nog geen opnamen.",
  "survey.rejected": "{{count}} meting(en) verworpen, te ver van de rest",
  "survey.removePhoto": "Foto verwijderen",
  "survey.save": "Opname bewaren",
  "survey.send": "Nu versturen",
  "survey.sendFailed": "Versturen lukt nu niet. De opnamen blijven op het toestel.",
  "survey.sending": "Bezig met versturen…",
  "survey.start": "Meting starten",
  "survey.statusPending": "Wacht op netwerk",
  "survey.statusRejected": "Opname geweigerd door de server.",
  "survey.statusSent": "Verstuurd",
  "survey.stop": "Meting stoppen",
  "survey.title": "Veldopname",
  "survey.tooImprecise": "De nauwkeurigheid is nog onvoldoende. Ga bij metalen constructies vandaan en wacht even.",
  "survey.waiting": "Wachten op gps…",
  "tab.crew": "Groep",
  "tab.diary": "Dagboek",
  "tab.lineup": "Programma",
  "tab.map": "Plattegrond",
  "tab.me": "Ik",
  "tab.places": "Locaties"
}
